import { EventEmitter } from 'common/utils/event-emitter';

export enum LottieDirection {
	forward = 'forward',
	backward = 'backward',
}

export enum LottieTrigger {
	// --- Component scope ---

	// on page load + in viewport
	load = 'load',
	// on block click
	onClick = 'onClick',
	// on block hover
	onHover = 'onHover',

	// --- Card scope ---

	// on select any answer in card
	onCardAnswer = 'onCardAnswer',
	// on answer card correctly
	onCardAnswerCorrect = 'onCardAnswerCorrect',
	// on answer card incorrectly
	onCardAnswerIncorrect = 'onCardAnswerIncorrect',
	// on leads form card submit click
	onSubmit = 'onSubmit',

	// todo: how to run animation when clicking on some particular block in card?
	//       like click on `ButtonA` will start animation of `ButtonB`
}

export type LottiePlaybackPayload =
	| { action: 'previewAnimation'; lottieId: string }
	| { action: 'onAnswer'; answerNodeId: string; isCorrect: boolean }
	| { action: 'onMultipleAnswerSelect'; answerNodeId: string }
	| { action: 'onSubmit' };

export type LottiePlaybackEvent = { type: 'playback'; data: LottiePlaybackPayload };

export const lottieDefaultKeepRatio = true;

export const LottieDefaultTrigger = LottieTrigger.load;

export const LottieEvEm = new EventEmitter<LottiePlaybackEvent>();
